var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, Typography, useToast } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useDeleteEntry } from 'app/domains/filesystem';
import { useDocumentName } from './useDocumentName';
export function DeleteDocumentDialog(props) {
    const { id, onDeleted, onClose, onUpdate } = props;
    const [deleteEntry, { loading }] = useDeleteEntry(id, { onDeleted, onUpdate });
    const { documentName } = useDocumentName(id);
    const { addToast } = useToast();
    const handleConfirm = () => __awaiter(this, void 0, void 0, function* () {
        try {
            yield deleteEntry();
            onClose();
            addToast({
                appearance: 'success',
                title: t({
                    message: 'Document deleted',
                    comment: 'Delete document success toast',
                }),
            });
        }
        catch (_a) {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'Error occurred while deleting document',
                    comment: 'Delete document error toast',
                }),
            });
        }
    });
    return (<Dialog size="sm">
      <DialogHeader title={t({
            message: 'Delete document',
            comment: 'Delete document dialog - Title',
        })} icon={<Falcon icon="trash-can"/>}/>
      <DialogContent>
        <Typography>
          <Trans comment="Warning message for delete document dialog">
            Are you sure you want to delete <b>{documentName}</b>? This action is irreversible.
          </Trans>
        </Typography>
      </DialogContent>
      <DialogFooter>
        <Button size="small" appearance="secondary" disabled={loading} onClick={onClose}>
          <Trans comment="Delete document dialog - Cancel button label">Cancel</Trans>
        </Button>
        <Button size="small" appearance="danger" disabled={loading} onClick={handleConfirm}>
          <Trans comment="Delete document dialog - Delete button label">Delete</Trans>
        </Button>
      </DialogFooter>
    </Dialog>);
}
